export default {
  white: '#ffffff',
  whiteBackground: '#F2F2F2',
  black: '#000000',
  lightGreen: '#52C975',

  gray: '#818181', // Usual gray color for texts
  lightGray: '#A5A5A5', // For placeholders and cancel button
  liteGray: '#C6C6C6', // For placeholders and cancel button
  darkGray: '#6F6F6F', // For icon-buttons or long text on white background
  darkGrayRecords: '#56595C',

  // The following colours are used only on the website
  orange: '#F28D10',

  redDanger: '#FF2929',
  redSoft: '#FF8282',

  blue: '#137CC3',
  opacityBlue: '#137CC380',
  darkBlue: '#0C74AD',
  lightBlue: '#35B2F8',
  skyBlue: '#00C0FA',
  red: '#b00020',

  nativeTouchFeedbackAndroid: '#DFF2FD',

  helpersGray600: '#4B5563',
};
